import React, {useState, useEffect} from 'react';

import './App.css';
import {localStorageSetItem, localStorageGetItem} from "./misc"
import params from "./data/params.json";
import {useLessons} from "./DataContext";
import {useServer} from "./ServerContext";
import {useHash} from "./HashContext";


function Prefs({onBack}) {

    // Contexts imports
    const {isAllowedChangeUser, addEvent2ServerQueue, cleanLocalStorageChangeUser} = useServer();
    const {convertCurrentUsernameIntoHash,isHash} = useHash()

    // bookName management
    const {bookName, setBookName} = useLessons();
    useEffect(() => {
        localStorage.setItem("selectedLesson","1")
    })

    // useState for the available voices
    const [voices, setVoices] = useState([]);

    // useEffect to load the voice list at first render
    useEffect(() => {
        // Récupère la liste de toutes les voix, et ne garde que celles en hébreu
        const refreshVoices = () => {
            const allVoices = speechSynthesis.getVoices();

            // Filtrer uniquement les voix hébreu
            const hebVoices = allVoices.filter((v) => {
                const lang = v.lang.toLowerCase();
                return lang.includes("il") || lang.includes("ar");
            });
            setVoices(hebVoices);
        };
        // On charge la liste de voix au montage
        refreshVoices();
        // On écoute l'événement "voiceschanged" pour recharger si besoin
        const handleVoicesChanged = () => {
            refreshVoices();
        };
        speechSynthesis.addEventListener('voiceschanged', handleVoicesChanged);
        return () => {
            speechSynthesis.removeEventListener('voiceschanged', handleVoicesChanged);
        };
    }, []);

    // useState for the selected voice --> localStorage
    const [selectedVoice, setSelectedVoice] = useState(() => {
        return localStorageGetItem('audioVoice') || null;
    });

    // Quand on clique sur une voix, on la sauvegarde + on dit "shalom"
    const handleSelectVoice = (voiceName, speed = null) => {
        if (voiceName !== selectedVoice) {
            setSelectedVoice(voiceName);
        }

        // Récupérer l'objet voice pour cette voix
        const found = voices.find((v) => v.name === voiceName);
        if (found) {
            const utterance = new SpeechSynthesisUtterance("שָׁלוֹם,מַה נִשְׁמַע"); // Parle en hébreu
            utterance.voice = found;
            utterance.rate = speed ? speed : speechSpeed;
            speechSynthesis.speak(utterance);
            console.log("Voice found, uterance = ", found, utterance);
        } else
            console.log("Voice not found");
    };

    // useState for prosody
    const [advancedProsody, setAdvancedProsody] = useState(() => {
        const saved = localStorageGetItem('advancedProsody');
        return saved || "0";
    });

    // useState for speechSpeed
    const [speechSpeed, setSpeechSpeed] = useState(() => {
        const saved = localStorageGetItem('speechSpeed');
        return saved || "0.9";
    });
    const handleSpeechSpeedChange = (e) => {
        setSpeechSpeed(parseFloat(e.target.value)); // Met à jour l'état
    }
    const handleSpeechSpeedEnd = (e) => {
        handleSelectVoice(selectedVoice)
    }

    // useState for repeatFactor
    const [repeatFactor, setRepeatFactor] = useState(() => {
        const saved = localStorageGetItem('repeatFactor');
        return saved || "1";
    });
    const handleRepeatFactorChange = (e) => {
        setRepeatFactor(parseFloat(e.target.value))
        addEvent2ServerQueue("updatePrefs")
    };

    // useState for username
    const [username, setUsername] = useState(() => {
        return localStorage.getItem('currentUsername') || '';
    });
    const handleUserNameChange = (e) => {
        setUsername(e.target.value.trim().toLowerCase());
    }
    // Empêcher les caractères interdits
    const handleKeyDown = (e) => {
        // Autoriser certaines touches de contrôle
        const allowedControlKeys = [
            "Backspace",
            "ArrowLeft",
            "ArrowRight",
            "Delete",
        ];

        // Si touche de contrôle → ok
        if (allowedControlKeys.includes(e.key)) return;

        // Vérifier si la touche correspond à [a-zA-Z0-9-]
        if (!/^[a-zA-Z0-9-]$/.test(e.key)) {
            e.preventDefault();
        }

        if (username === localStorage.getItem('currentUsername') && isHash()) {
            setHashKeysLockedDisabled(true)
            setHashedKeys(true);
        }
        else if (username === localStorage.getItem('currentUsername') && !isHash()) {
            setHashKeysLockedDisabled(false)
            setHashedKeys(false);
        }
        else {
            setHashKeysLockedDisabled(true)
            setHashedKeys(false);
        }
    };

    // useState for the speech to text API
    const [speech2Text, setSpeech2Text] = useState(
        localStorage.getItem("speech2Text") || "webapi");
    useEffect(() => localStorage.setItem("speech2Text", speech2Text), [speech2Text]);

    // useState for recording --> not working yet
    const [recordedText, setRecordedText] = useState(null);
    const onRecording = (text) => {
        console.log("BINGO " + text + "?")
    }

    // useState for hashing
    const [hashedKeys, setHashedKeys] = useState(() =>  isHash() ? "1" : "0")
    const [hashedKeysDisabled, setHashKeysLockedDisabled] = useState(isHash())

    // Save what is needed to be saved when leaving
    const saveall = () => {
        localStorage.setItem('audioVoice', selectedVoice);
        localStorage.setItem('speechSpeed', speechSpeed);
        localStorage.setItem('repeatFactor', repeatFactor);
        localStorage.setItem('advancedProsody', advancedProsody);
        localStorage.setItem('hashedKeys', hashedKeys);
        localStorage.setItem('bookName', bookName);
    }

    // leaving
    const leave = async () => {
        const previousUsername = localStorage.getItem('currentUsername');

        if (previousUsername !== username) {
            localStorage.setItem('currentUsername', username);
            addEvent2ServerQueue("changeUser");
            cleanLocalStorageChangeUser();
        }

        if (hashedKeys==='1' && !isHash() && previousUsername === username)
            await convertCurrentUsernameIntoHash()

        onBack();
    };

    return (
        <div className="main-container ">
            <div className="title-container top">
                <div className="title-container-title">Préférences</div>
                <button className="button-secondary"
                        disabled={username === ""}
                        onClick={() => {
                            saveall();
                            leave();
                        }}>
                    ✅
                </button>
            </div>

            <div className="section-container text-display prefs-container">

                <div className="preference">
                    <div className={"preference-title"}>
                        Nom d'utilisateur
                        <span
                            className={"preference-title-note"}>{!isAllowedChangeUser ? " (inchangeable hors connexion)" : null} </span>
                    </div>
                    <div className="preference-content">
                        <input
                            type="text"
                            value={username}
                            onChange={handleUserNameChange}
                            onKeyDown={handleKeyDown}
                            placeholder="Votre nom d'utilisateur "
                            className={"username-input"}
                            disabled={!isAllowedChangeUser}
                        />
                    </div>
                </div>

                <div className="preference">
                    <div className="preference-title">
                        Paramètres de voix
                    </div>
                    <div className={"preference-content"}>
                        <div className="voice-list-container">
                            {voices.length === 0
                                ? (<p style={{marginTop: '1rem'}}>Aucune voix hébreu détectée.</p>)
                                : (
                                    <div
                                        style={{
                                            marginTop: '1rem',
                                            maxHeight: '10rem',
                                            overflowY: 'auto',
                                            border: '1px solid #ccc',
                                            borderRadius: '0.3rem',
                                            width: '300px'
                                        }}
                                    >
                                        <div>
                                            <table style={{width: '100%', borderCollapse: 'collapse'}}>
                                                <thead>
                                                <tr>
                                                    <th style={{
                                                        textAlign: 'left',
                                                        padding: '0.5rem',
                                                        borderBottom: '1px solid #ccc'
                                                    }}>
                                                        <span className="preference-text">    Choisissez la voix </span>
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {voices.map((v) => {
                                                    const isSelected = (selectedVoice === v.name);
                                                    return (
                                                        <tr className={"voice-entry"}
                                                            key={v.name + v.lang}
                                                            onClick={() => handleSelectVoice(v.name)}
                                                            style={{
                                                                backgroundColor: isSelected ? '#ddd' : 'transparent',
                                                            }}
                                                        >
                                                            <td style={{
                                                                textAlign: 'left',
                                                                padding: '0.5rem',
                                                                borderBottom: '1px solid #eee'
                                                            }}>
                                                                {v.name} ({v.lang})
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                )}
                        </div>
                        <div className="preference-explication">
                            Pour installer une autre voix hébreu sur Android, il faut chercher dans les réglages
                            "synthèse vocale" (Bixby) et choisir la synthèse vocale de google (et pas celle de Samsung
                            ou autre).
                            Puis il faut sélectioner/charger l'hébreu.
                        </div>
                    </div>

                    <div className="preference-title second">
                        Vitesse de lecture :
                    </div>
                    <div className="preference-content">

                        <div className="speechSpeedSlider-container">
                            <input type="range" onChange={handleSpeechSpeedChange}
                                   onMouseUp={handleSpeechSpeedEnd}
                                   onTouchEnd={handleSpeechSpeedEnd}
                                   min="0.4" max="1.8" value={speechSpeed} step="0.1"
                            />
                            <div className="speechSpeedSlider-box">
                                {speechSpeed}
                            </div>
                        </div>
                    </div>

                    <div className="preference-title second">
                        Méthode de speech to text :
                    </div>
                    <div className={"preference-content"}>
                    <div className="preference-content">
                            <select value={speech2Text}
                                    onChange={(e) => setSpeech2Text(e.target.value)}
                            >
                                <option value="webapi"> Webapi</option>
                                <option value="whisper"> Whisper</option>
                            </select>
                        </div>
                    <div className="preference-explication">
                            Préférer Webapi. Si ca ne marche pas sélectionner Whisper.
                        </div>
                </div>
                </div>

                <div className="preference">
                    <div className={"preference-title"}>
                        Choix du livre de cours
                    </div>
                    <div className="preference-content">
                        <select value={bookName} onChange={(e) => {
                            setBookName(e.target.value)
                        }}>
                            {Object.keys(params).map((k) => (
                                <option key={k} value={k}>
                                    {params[k].name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="preference-explication">
                        Choisissez le livre de cours que vous voulez utiliser.
                    </div>
                </div>

                <div className="preference">
                    <div className={"preference-title"}>
                        Paramètres avancés :
                    </div>

                    <div className={"preference-title"}>
                        Répétition d'apprentissage
                    </div>
                    <div className="preference-content">
                        <div className="speechSpeedSlider-container">
                            <input
                                type="range"
                                min="1"
                                max="4" step="1"
                                value={repeatFactor}
                                onChange={handleRepeatFactorChange}
                            />
                            <div className="speechSpeedSlider-box">
                                {repeatFactor}
                            </div>
                        </div>
                        <div className="preference-explication">
                            Nombre de fois qu'un exercice doit être réussi pour atteindre 100%
                        </div>
                    </div>

                    <div className="preference-title second"> Prosodie avancée pour la lecture des textes :</div>
                    <div className="preference-content">
                        <div className="preference-content">
                            <label htmlFor="advancedProsody" className="checkbox-row">
                                <input
                                    id="advancedProsody"
                                    type="checkbox"
                                    checked={advancedProsody === "1"}
                                    onChange={(e) => setAdvancedProsody(e.target.checked ? "1" : "0")}
                                />
                                <span style={{marginLeft: 8}}>
                                    Activer la prosodie avancée
                                </span>
                            </label>
                        </div>

                        <div className="preference-explication">
                            Préférer la lecture avancée, mais la synchronisation avec l'affichage
                            du texte peut ne pas marcher sur certains appareils.
                        </div>
                    </div>

                    <div className="preference-title second"> Optimisation mémoire</div>
                    <div className="preference-content">
                        <div className="preference-content">
                            <label htmlFor="hashedKeys" className="checkbox-row">
                                <input
                                    id="hashedKeys"
                                    type="checkbox"
                                    checked={hashedKeys === "1"}
                                    disabled={hashedKeysDisabled}
                                    onChange={(e) => setHashedKeys(e.target.checked ? "1" : "0")}
                                />
                                <span style={{marginLeft: 8}}>
                                    Optimisation par hashage les mots et les phrases.
                                </span>
                            </label>
                        </div>
                         <div className="preference-explication">
                            Attention : une fois optimisé on ne peut pas revenir en arrière
                        </div>

                    </div>
                </div>
            </div>
        </div>

)
    ;
}


export default Prefs;

        /*






            </div>


        </div>


</div>
    */